import React from "react";
import logo from "./logo.svg";
import 'react-circular-progressbar/dist/styles.css';
import "./output.css";
import "react-datepicker/dist/react-datepicker.css";
import { AdminRoute } from "./routes/Adminroutes";
import Spinner from "./components/generic/Spinner";
import { useStateGetter } from "./hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "./hooks/statehooks/UseStateSettersHook";
import Modal from "./components/generic/Modal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
import 'react-calendar/dist/Calendar.css';


function App() {
  const { isloading , showWizard, showmodal} = useStateGetter();
  
  return (
    <div className="overflow-y-hidden overflow-x-hidden w-screen h-screen bg-customGray ">
      <Spinner loading={isloading} />
   
      <AdminRoute />
      <ToastContainer /> 

      {showmodal && <Modal />}

  
    </div>
  );
}

export default App;
